import { NgClass } from '@angular/common';
import { Component, effect, EventEmitter, inject, input, Output, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { DrawerModes, DrawerPanel } from '../../abstract/drawer.abstract.component';

@Component({
  selector: 'aura-drawer',
  templateUrl: './drawer.component.html',
  imports: [MatSidenavModule, MatIconModule, NgClass, MatButtonModule],
})
export class AuraDrawerComponent {
  @ViewChild('drawer') drawer!: MatDrawer;

  title = input<string>('');
  drawerMode = input<DrawerModes>(DrawerModes.SIDE);
  drawerOpened = input<boolean>(false);
  selectedPanel = input<DrawerPanel | null>(null);
  panels = input<DrawerPanel[]>([]);
  router = inject(Router);
  route = inject(ActivatedRoute);

  @Output() readonly panelSelected = new EventEmitter<DrawerPanel>();
  readonly currentPanel = signal<DrawerPanel | null>(null);

  constructor() {
    effect(() => {
      const inputVal = this.selectedPanel();
      if (inputVal) {
        this.currentPanel.set(inputVal);
        void this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { drawer: inputVal.id },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });
  }

  goToPanel(panel: DrawerPanel) {
    this.currentPanel.set(panel);
    this.panelSelected.emit(panel);

    if (this.drawerMode() === DrawerModes.OVER) {
      this.drawer.close();
    }
  }

  initSelectedPanel(panel: DrawerPanel) {
    if (panel) {
      this.goToPanel(panel);
    }
  }
}
